<template>
  <footer>
    <div class="footer-top">
      <div class="grid-container">
        <div class="grid-x">
          <div class="cell small-12 medium-3">
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                <path fill="#232A33" fill-rule="evenodd" d="M15.9999619 3.50002503c0 1.93749538-.9999977 3.78124099-2.9999929 5.53123677v3.9687406c0 .2291659-.0624998.4479154-.1874995.6562484-.1249997.208333-.2916659.3645826-.4999989.4687489l-3.49999161 1.7499958c-.27083285.1249997-.5468737.1562497-.82812303.0937498-.28124933-.0624998-.51562377-.208333-.70312332-.437499-.18749955-.2291659-.28124933-.4895823-.28124933-.7812481v-2.0624951c-.43749896.1874996-.89583136.3749991-1.37499672.5624987-.208333.0833333-.38541559.0520834-.53124873-.0937498l-2.24999464-2.2499946c-.14583314-.1458332-.17708307-.3229158-.09374978-.5312488.18749956-.4791653.37499911-.9374977.56249866-1.3749967H1.24999702c-.29166581 0-.55208218-.09374976-.78124814-.28124931-.22916596-.18749955-.3749991-.42187399-.43749895-.70312332C-.03124993 7.73438994 0 7.45834909.1249997 7.18751624l1.74999583-3.49999165c.10416626-.208333.26041589-.37499911.46874888-.49999881.208333-.1249997.42708248-.18749955.65624844-.18749955h3.96874054C8.71872921 1.00003099 10.5624748.00003338 12.4999702.00003338c.6041651 0 1.0677059.02083344 1.3906217.06249985.3229157.04166641.7864566.13541618 1.3906217.28124933.208333.06249985.3333327.18749955.3749991.3749991.1458331.62499851.2395829 1.0937474.2812493 1.40624665.0416664.31249926.0624999.77083166.0624999 1.37499672zM1.65624605 7.5000155h2.37499434c.5833321-1.12499732 1.17708068-2.12499494 1.78124575-2.99999285H3.15624247L1.65624605 7.5000155zm2.71874352 2.8124933l1.31249687 1.3124969c2.45832763-.9999977 4.46873936-2.1562449 6.03123566-3.46874177 1.854162-1.56249627 2.7812433-3.11457606 2.7812433-4.6562389 0-.41666551-.0104165-.71874828-.0312499-.90624784-.0208334-.27083284-.0624998-.5833321-.1249997-.93749776-.3541657-.06249985-.6666649-.10416626-.9374978-.1249997-.1874995-.02083344-.4895823-.03124993-.9062478-.03124993-1.5416628 0-3.09374263.92708128-4.6562389 2.78124337-1.31249687 1.56249628-2.46874411 3.57290799-3.46874173 6.03123563zm7.12498303 2.531244v-2.6562437c-.8958314.6249985-1.89582899 1.2187471-2.99999287 1.7812457v2.3749944l2.99999287-1.4999964zm0-9.84372657c.4166655 0 .7708316.14583314 1.0624974.43749895.2916659.29166582.437499.64583196.437499 1.06249747 0 .41666551-.1458331.77083165-.437499 1.06249747-.2916658.29166581-.6458319.43749895-1.0624974.43749895s-.7708317-.14583314-1.0624975-.43749895c-.2916658-.29166582-.43749894-.64583196-.43749894-1.06249747 0-.41666551.14583314-.77083165.43749894-1.06249747.2916658-.29166581.645832-.43749895 1.0624975-.43749895z" />
              </svg>
              Kom igång
            </h3>
            <ul>
              <li>
                <router-link :to="{ name: 'create-ad' }">
                  Skapa annons
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'adlist' }">
                  Sök annonser
                </router-link>
              </li>
              
              <!-- <li>
                <a href="">Såhär funkar det</a>
              </li>
              <li>
                <a href="">Logga in</a>
              </li> -->
            </ul>
          </div>
          <div class="cell small-12 medium-3">
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16">
                <path
                  fill="#232A33"
                  fill-rule="evenodd"
                  d="M16.4999607 5.3437706c.2708328.0416664.4843738.1666661.6406234.3749991.1562497.208333.229166.437499.2187495.6874984-.0104165.2499994-.1093747.4687489-.2968743.6562484l-3.3124921 3.2187424.7812482 4.5624891c.0416664.2499994-.0052085.4843738-.1406247.7031233-.1354162.2187495-.3281242.3593742-.5781236.421874-.2499994.0624999-.4895824.0312499-.7187483-.0937498l-4.09374026-2.1249949-4.09374024 2.1249949c-.22916596.1249997-.46874888.1562497-.71874828.0937498-.24999941-.0624998-.44270744-.2031245-.57812363-.421874-.13541618-.2187495-.18229107-.4531239-.14062466-.7031233l.78124814-4.5624891-3.3124921-3.2187424c-.18749956-.1874995-.28645781-.406249-.2968743-.6562484-.01041648-.2499994.06249985-.4791654.21874948-.6874984.15624963-.208333.36979063-.3333327.64062347-.3749991l4.56248913-.6562484L8.0937307.562532c.1249997-.2499994.30729078-.4166655.5468737-.4999988.23958292-.0833333.47916536-.0833333.71874829 0 .23958292.0833333.42187399.2499994.54687369.4999988l2.03124512 4.1249902 4.5624892.6562484zM12.156221 9.7500101l3.1249926-3.0624927-4.3437397-.6249985-1.93749536-3.9374906-1.93749538 3.9374906-4.34373964.6249985 3.12499255 3.0624927-.71874829 4.3437397 3.87499076-2.0624951 3.87499076 2.0624951-.7187483-4.3437397z" />
              </svg>
              Om bytbostad.se
            </h3>
            <ul>
              <li>
                <router-link :to="{ name: 'about-us' }">
                  Om oss
                </router-link>
                <!-- <a href="">Om oss</a> -->
              </li>
              <!-- <li>
                <router-link :to="{ name: 'jobs' }">
                  Jobba med oss
                </router-link>
              </li> -->
              <li>
                <router-link :to="{ name: 'cookies' }">
                  Cookiepolicy
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'terms' }">
                  Användarvillkor
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'lagenhetsbyte' }">
                  Lägenhetsbyte
                </router-link>
              </li>
              <!-- <li>
                <a href="">Cookiepolicy</a>
              </li> -->
            </ul>
          </div>
          <div class="cell small-12 medium-3">
            <h3>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
                <path
                  fill="#232A33"
                  fill-rule="evenodd"
                  d="M7.9999809 15.7499958c-1.3958301 0-2.6874936-.3489576-3.8749907-1.0468725-1.1874972-.6979148-2.1302034-1.6406211-2.8281183-2.8281182C.5989571 10.6875079.2499994 9.3958445.2499994 8.0000143c0-1.3958302.3489577-2.6874936 1.0468725-3.8749908.6979149-1.1874971 1.6406211-2.1302034 2.8281183-2.8281182C5.3124873.5989904 6.6041508.2500328 7.9999809.2500328c1.3958302 0 2.6874936.3489576 3.8749908 1.0468725 1.1874972.6979148 2.1302034 1.6406211 2.8281182 2.8281182.6979149 1.1874972 1.0468725 2.4791606 1.0468725 3.8749908 0 1.3958302-.3489576 2.6874936-1.0468725 3.8749908-.6979148 1.1874971-1.640621 2.1302034-2.8281182 2.8281182-1.1874972.6979149-2.4791606 1.0468725-3.8749908 1.0468725zm-3.2187423-2.4062442c.9791642.604165 2.0520786.9062478 3.2187423.9062478 1.1666638 0 2.2395782-.3020828 3.2187424-.9062478l-1.6562461-1.6562461c-.4999988.208333-1.0208311.3124993-1.5624963.3124993s-1.0624974-.1041663-1.5624962-.3124993l-1.6562461 1.6562461zm5.7187364-5.3437373c0-.6874984-.244791-1.2760385-.7343733-1.7656208-.4895823-.4895823-1.0781224-.7343732-1.7656208-.7343732-.6874983 0-1.2760384.2447909-1.7656208.7343732-.4895823.4895823-.7343732 1.0781224-.7343732 1.7656208s.2447909 1.2760385.7343732 1.7656208c.4895824.4895823 1.0781225.7343732 1.7656208.7343732.6874984 0 1.2760385-.2447909 1.7656208-.7343732.4895823-.4895823.7343733-1.0781224.7343733-1.7656208zm2.8437432 3.2187423c.6041651-.9791641.9062478-2.0520786.9062478-3.2187423s-.3020827-2.2395781-.9062478-3.2187423l-1.6562461 1.656246c.208333.4999988.3124993 1.0208311.3124993 1.5624963s-.1041663 1.0624975-.3124993 1.5624963l1.6562461 1.656246zM11.2187233 2.656277c-.9791642-.604165-2.0520786-.9062478-3.2187424-.9062478-1.1666637 0-2.2395781.3020828-3.2187423.9062478l1.6562461 1.6562461c.4999988-.208333 1.020831-.3124993 1.5624962-.3124993s1.0624975.1041663 1.5624963.3124993l1.6562461-1.6562461zM2.6562437 4.781272c-.6041651.9791642-.9062479 2.0520786-.9062479 3.2187423s.3020828 2.2395782.9062479 3.2187423l1.656246-1.656246c-.208333-.4999988-.3124992-1.0208311-.3124992-1.5624963s.1041662-1.0624975.3124992-1.5624963l-1.656246-1.656246z" />
              </svg>
              Kundtjänst &amp; hjälp
            </h3>
            <ul>
              <!-- <li>
                <a href="">Kundtjänst</a>
              </li> -->
              <li><a href="https://m.me/bytbostad" target="_blank">@bytbostad på Messenger</a></li>
              <li><a href="https://fb.com/bytbostad" target="_blank">@bytbostad på Facebook</a></li>
              <li>
                <router-link :to="{ name: 'faq' }">
                  Frågor &amp; Svar
                </router-link>
              </li>
              <li>
                <a href="mailto:info@bytbostad.se">info@bytbostad.se</a>
              </li>

              <li>
                <a href="https://www.domstol.se/amnen/hyra-bostadsratt-och-arrende/hyra-av-bostad-och-lokal/byta-och-overlata/byta-bostad/" target="_blank">Hyresnämnden</a>
              </li>
            </ul>
          </div>
          <div class="cell small-12 medium-3"></div>
        </div>
      </div>
    </div>

    <div class="footer-btm">
      <div class="grid-container">
        <div class="grid-x">
          <div class="cell small-12">
            <p>
              &copy; 2009-{{ new Date().getFullYear() }} Svenska Bostadssajterna
              AB
            - 559160-8657</p>
           <!-- <p>
             Surbrunnsgatan 10, Stockholm
            </p>
            -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style></style>
